import React from "react"
import "../styles/global.css"
import Services from "../components/services"
import Layout from "../templates/layout"
import Reasons from "../components/reasons"
import Hero from "../components/hero"
import Clientlogos from "../components/clientlogos"
import Vidtestimonials from "../components/vidtestimonials"
import SEO from "../components/seo"
import { graphql } from 'gatsby'

export default ({ location, data }) => {
  return (
    <>
      <SEO
        title="Bankjoy — Digital Banking for Banks and Credit Unions"
        description="Bankjoy delivers award-winning banking technology, including mobile banking, online banking, e-statements, online account opening, online loan origination, and conversational AI to banks and credit unions — big and small."
        url="https://bankjoy-headless.vercel.app/"
        ogImage={data.prismicHomepage.data.ogimage.url}
      />
      <Layout location={location} isHome={true} containerClassName="">
        <div>
          <Hero />     
          <Services />
          <Reasons />
          <Vidtestimonials />
          <Clientlogos />
        </div>
      </Layout>
    </>
  )
}

export const query = graphql`
  {
    prismicHomepage {
      data {
        ogimage{
          url
        }
      }
    }
  }
`

